import React, { useContext } from "react";

import { makeStyles } from "@material-ui/core/styles";
import SpeedDial from "@material-ui/lab/SpeedDial";
import Icon from "@material-ui/core/Icon";
import {
  ListItemText,
  ListItem,
  List,
  Drawer,
  Divider,
  ListSubheader,
  CircularProgress,
  ListItemIcon,
  LinearProgress,
  ListItemSecondaryAction,
  IconButton,
  Box,
  Badge,
  Grid,
} from "@material-ui/core";
import { grey } from "@material-ui/core/colors";
import { useSelector, useDispatch } from "react-redux";
import "./speedDial.css";
import { MasterContext } from "../../context/master";
import { RemoveTaskFromTaskList } from "../../actions";
import { useTheme } from "@material-ui/styles";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTasks } from "@fortawesome/free-solid-svg-icons";
import { useTranslation } from "react-i18next";
import { LANG_TURKISH } from "./../../constants/language";

const drawerWidth = 320;

const useStyles = makeStyles((theme) => ({
  root: {
    transform: "translateZ(0px)",
    flexGrow: 1,
    margin: 0,
    top: "auto",
    left: "auto",
    bottom: 20,
    right: 20,
    position: "fixed",
  },
  radioGroup: {
    margin: theme.spacing(1, 0),
  },
  speedDial: {
    position: "fixed",
    "&.MuiSpeedDial-directionUp, &.MuiSpeedDial-directionLeft": {
      bottom: theme.spacing(2),
      right: theme.spacing(2),
    },
    "&.MuiSpeedDial-directionDown, &.MuiSpeedDial-directionRight": {
      top: theme.spacing(2),
      left: theme.spacing(2),
    },
  },
  drawerPaper: {
    width: drawerWidth,
    background: theme.palette.appBarBackground.main,
    color: theme.palette.appBarForeground.main,
  },
  toolbar: { ...theme.mixins.toolbar, display: "flex", alignItems: "center" },
  brand: {
    flex: "auto",
    minHeight: 40,
  },
  taskIcon: {
    minWidth: 25,
  },
  taskCheckIcon: {
    fontSize: "1.5rem",
    color: theme.palette.primary.main,
    marginRight: 8,
  },
  taskErrorIcon: {
    fontSize: "2rem",
    color: theme.palette.error.main,
  },
  progressIcon: {
    color: theme.palette.background.paper,
  },
  taskTexts: {
    display: "flex",
    flexDirection: "column",
    fontSize: "0.975rem",
  },
}));

export default function SpeedDials() {
  const language = useSelector((state) => state.language);
  const classes = useStyles();
  const [direction] = React.useState("up");
  const [open, setOpen] = React.useState(false);
  const [hidden] = React.useState(false);
  const taskList = useSelector((state) => state.taskList);
  const context = useContext(MasterContext);
  const dispatch = useDispatch();
  const theme = useTheme();
  const handleDelete = () => {};
  const { t } = useTranslation();

  const options = {
    year: "numeric",
    month: "numeric",
    day: "numeric",
    hour: "numeric",
    minute: "numeric",
  };

  const handleOpen = () => {
    setOpen(true);
  };

  return (
    <div className={classes.root}>
      <SpeedDial
        ariaLabel="SpeedDial"
        className={classes.speedDial}
        hidden={hidden}
        icon={
          taskList.filter(
            (task) => task.Progress !== 100 && task.Progress !== -1
          ).length > 0 ? (
            <Badge
              badgeContent={
                taskList.filter(
                  (task) => task.Progress !== 100 && task.Progress !== -1
                ).length
              }
              color="primary"
            >
              <Icon className="animatedPulse" fontSize="large">
                assignment
              </Icon>
            </Badge>
          ) : (
            <Icon fontSize="large" style={{ color: "#ffffff" }}>
              assignment
            </Icon>
          )
        }
        open={open}
        onClick={handleOpen}
        direction={direction}
        FabProps={{
          style: {
            backgroundColor: "#212121",
          },
        }}
      ></SpeedDial>
      <Drawer
        classes={{
          paper: classes.drawerPaper,
        }}
        onClose={() => setOpen(false)}
        anchor="right"
        open={open}
        onKeyDown={() => setOpen(false)}
      >
        <div className={classes.toolbar}>
          <div className={classes.brand}>
            <ListSubheader color="inherit" style={{ fontSize: "0.875rem	" }}>
              {t("Task List")}
            </ListSubheader>
          </div>
        </div>
        <Divider />
        <List disablePadding>
          {taskList.map((task) => (
            <ListItem key={task.Id}>
              <ListItemIcon className={classes.taskIcon}>
                {parseInt(task.Progress) === 100 ? (
                  <Icon className={classes.taskCheckIcon}>check</Icon>
                ) : parseInt(task.Progress) !== -1 ? (
                  <div>
                    <CircularProgress size={25} />
                  </div>
                ) : (
                  <Icon className={classes.taskErrorIcon}>error_outline</Icon>
                )}
              </ListItemIcon>
              <ListItemText
                disableTypography
                primary={
                  <span className={classes.taskTexts}>
                    <span>{t(task.JobType)}</span>
                    <span>
                      {new Date(task.CreateDate).toLocaleString(
                        language.Current === LANG_TURKISH ? "tr-TR" : "en-US",
                        options
                      )}
                    </span>
                    <span>{JSON.parse(task.MetaData).HostName}</span>
                  </span>
                }
                secondary={
                  task.Progress !== -1 && (
                    <LinearProgress
                      variant={
                        task.Progress === 100 ? "determinate" : "indeterminate"
                      }
                      value={task.Progress}
                    ></LinearProgress>
                  )
                }
              ></ListItemText>
              <ListItemSecondaryAction>
                {(task.Progress === 100 || task.Progress === -1) && (
                  <IconButton
                    onClick={() => {
                      dispatch(RemoveTaskFromTaskList(task.Id));
                      context.DeleteTask(task.Id);
                    }}
                    size="small"
                  >
                    <Icon
                      fontSize="small"
                      style={{
                        color:
                          theme.palette.type === "dark" ? "white" : "black",
                      }}
                    >
                      close
                    </Icon>
                  </IconButton>
                )}
              </ListItemSecondaryAction>
            </ListItem>
          ))}
          {taskList.length === 0 && (
            <Grid
              container
              justify="center"
              alignItems="center"
              style={{ textAlign: "center" }}
              alignContent="center"
            >
              <Grid item md={12} sm={12} xs={12}>
                <Box marginTop={3} marginBottom={3}>
                  <FontAwesomeIcon
                    style={{ opacity: 0.4 }}
                    size="6x"
                    icon={faTasks}
                  ></FontAwesomeIcon>
                </Box>
              </Grid>
              <Grid item md={12} sm={12} xs={12}>
                <Box
                  color={theme.palette.textLight}
                  padding={2}
                  fontSize="0.9rem"
                >
                  {t("The Task List is Empty")}
                </Box>
              </Grid>
            </Grid>
          )}
        </List>
      </Drawer>
    </div>
  );
}
